/**
 * Every Quebec municipality (villages like Saint-Célestin included), most
 * populous first: the "Répertoire des municipalités du Québec" (MAMH,
 * Données Québec, CC BY 4.0), unorganized territories left out. Fetched once,
 * the first time a Quebec city field is used.
 */
const QUEBEC_CITIES_URL = '/data/quebec-municipalities.json';
let quebecCities: Promise<string[]> | null = null;
export const loadQuebecCities = () =>
  (quebecCities ??= fetch(QUEBEC_CITIES_URL)
    .then((response) => (response.ok ? response.json() : []))
    .catch(() => {
      quebecCities = null;
      return [];
    }));

/** "Saint-Célestin" and "st celestin" both become "saint celestin". */
export const cityKey = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\bste?\b\.?/g, (m) => (m.startsWith('ste') ? 'sainte' : 'saint'))
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

/** Up to `limit` names starting with the typed text, then containing it. */
export const matchCities = (
  cities: { name: string; key: string }[],
  typed: string,
  limit = 8
) => {
  const query = cityKey(typed);
  if (query.length < 2) return [];
  const starts: string[] = [];
  const contains: string[] = [];
  for (const city of cities) {
    if (city.key.startsWith(query)) starts.push(city.name);
    else if (contains.length < limit && city.key.includes(` ${query}`))
      contains.push(city.name);
    if (starts.length >= limit) break;
  }
  return [...starts, ...contains].slice(0, limit);
};
